<h1 mat-dialog-title align="center" class="text-green-600">{{title}}</h1>
<div mat-dialog-content>
    <p class="mat-body-1">{{message}}</p>
</div>
<div mat-dialog-actions align="center">
    <form [formGroup]="charityCheckForm">
        <mat-form-field>
            <input type="text" EIN ngControl="EIN" matInput maxlength="10" placeholder="Enter EIN" formControlName="ein">
            <mat-hint>Example: 12-1234567</mat-hint>
        </mat-form-field>
        <!-- <p-inputMask formControlName="ein" mask="99-9999999" characterPattern="[/(\d{0,2})(\d{0,7})/]"></p-inputMask>
        <small>Example: 12-1234567.</small> -->
    </form>
    <div align="center" style="margin-top: 15px;">
        <button mat-raised-button (click)="onNoClick()" color="warn">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="charityCheckForm.invalid"
            (click)="onSubmit()">Submit</button>
    </div>
</div>